// extracted by mini-css-extract-plugin
export default {"container":"InputFile_container__CrbKb","media":"InputFile_media__wCCu3","rotate":"InputFile_rotate__nMPUc"};